import { Button, Modal, Pagination, Row, Table, TableColumnsType } from "antd"
import { format, fromUnixTime } from "date-fns";
import { useEffect, useState } from "react";
import { exportFile } from "../../../common/ts/CommonFunctions";
import { useLazyGetRegisterAuctionDetailQuery } from "../../redux/ProfileApi"
import { BidderRegisterHistoryFile } from "../../types";

interface DetailProps {
    visible: boolean,
    toggleModal: () => void,
    bidderId: number,
}

interface HistoryDetailTable {
    key: number,
    createdDate: number,
    registerStatus: string,
    preCostStatus: string,
    fileDangKys: BidderRegisterHistoryFile[],
    fileDoiSoatTienDatTruoc: BidderRegisterHistoryFile[],
}

const AuctionHistoryDetail = ({ visible, toggleModal, bidderId }: DetailProps) => {
    const [trigger, response] = useLazyGetRegisterAuctionDetailQuery();
    const [page, setPage] = useState(1);
    const [tableData, setTableData] = useState<HistoryDetailTable[]>([]);
    const pageSize = 5;

    useEffect(() => {
        if (bidderId) {
            trigger(bidderId)
        }
    }, [trigger, bidderId])

    useEffect(() => {
        if (response.data?.bidderRegisterHistories?.length) {
            let newArray = [...response.data.bidderRegisterHistories].slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
            let newTableData: HistoryDetailTable[] = newArray.map((item, index) => {
                return ({
                    key: index,
                    createdDate: item.createdDate,
                    registerStatus: item.action,
                    preCostStatus: item.preCostAction,
                    fileDangKys: item.fileDangKys || [],
                    fileDoiSoatTienDatTruoc: item.fileDoiSoatTienDatTruoc || []
                })
            });

            setTableData(newTableData);
        } else {
            setTableData([])
        }
    }, [response, page])

    const historyDetailColumns: TableColumnsType<HistoryDetailTable> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 50,
            align: 'center',
            render: (value, record, index) => {
                return (<span
                    style={{ border: '1px solid black', padding: '7px 13px', borderRadius: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                    key={index}>
                    {(page - 1) * pageSize + index + 1}
                </span>)
            }
        },
        {
            title: "Ngày",
            dataIndex: 'createdDate',
            key: "createdDate",
            width: 120,
            render: (value) => {
                if (value) {
                    return (
                        <>
                            <div>{format(fromUnixTime(value / 1000), "dd/MM/yyyy")}</div>
                            <div>{format(fromUnixTime(value / 1000), "HH:mm:ss")}</div>
                        </>)
                }

                return <></>;
            }
        },
        {
            title: "Trạng thái đăng ký",
            dataIndex: "registerStatus",
            key: "registerStatus",
        },
        {
            title: "Trạng thái tiền đặt trước",
            dataIndex: "preCostStatus",
            key: "preCostStatus"
        },
        {
            title: "File đăng ký",
            key: "fileDangKys",
            dataIndex: "fileDangKys",
            width: 150,
            ellipsis: true,
            render: (value: BidderRegisterHistoryFile[]) => {
                if (value.length) {
                    return (
                        <>
                            {value.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="anchor-text text-ellipsis"
                                        onClick={() => downloadFile(item.fileUrl, item.fileName)}>
                                        {item.fileName}
                                    </div>
                                )
                            })}
                        </>)
                }
                return <></>
            }
        },
        {
            title: "File đối soát tiền đặt trước",
            key: "fileDoiSoatTienDatTruoc",
            dataIndex: "fileDoiSoatTienDatTruoc",
            width: 190,
            ellipsis: true,
            render: (value: BidderRegisterHistoryFile[]) => {
                if (value.length) {
                    return (
                        <>
                            {value.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="anchor-text text-ellipsis"
                                        onClick={() => downloadFile(item.fileUrl, item.fileName)}>
                                        {item.fileName}
                                    </div>
                                )
                            })}
                        </>)
                }
                return <></>
            }
        }
    ]

    const onPageChange = (currentPage: number) => {
        setPage(currentPage);
    }

    const downloadFile = (url: string, fileName: string) => {
        exportFile(url, fileName);
    }

    return (
        <Modal
            // width={1000}
            style={{ minWidth: 1000 }}
            visible={visible}
            onCancel={() => toggleModal()}
            className="custom-modal"
            footer={false}
            bodyStyle={{ padding: '24px 50px' }}
        >
            <div style={{ width: '100%', textAlign: 'center', marginTop: 20, fontSize: 30 }}>THÔNG TIN CHI TIẾT ĐĂNG KÝ THAM GIA ĐẤU GIÁ</div>
            <div style={{ width: '100%', textAlign: 'center', marginTop: 25, fontSize: 16 }}>
                <div className="text-overflow-custom-one-line" style={{ marginTop: 10 }}>Tài sản: <span>{` ${response.data?.product.productName || "-"}`}</span></div>
                <div className="text-overflow-custom-one-line" style={{ marginTop: 10 }}>Mã tài sản: <span>{` ${response.data?.product.productCode || "-"}`}</span></div>
                <div className="text-overflow-custom-one-line" style={{ marginTop: 10 }}>Mã quy chế: <span>{` ${response.data?.product?.statute?.code || "-"}`}</span></div>
            </div>
            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Lịch sử đăng ký đấu giá tài sản</div>

            <div className='custom-table-wrapper custom-table-modal'>
                <Table
                    columns={historyDetailColumns}
                    dataSource={tableData}
                    pagination={false} />
            </div>

            <Row justify="space-between" align="middle" style={{ marginTop: 35 }}>
                <span className="font-size-16">Tổng số <span className="font-bold">{` ${response.data?.bidderRegisterHistories?.length || 0} `}</span> kết quả</span>
                <Pagination
                    defaultCurrent={1}
                    total={response.data?.bidderRegisterHistories?.length || 0}
                    defaultPageSize={pageSize}
                    className="custom-pagination"
                    current={page}
                    onChange={onPageChange}
                    showSizeChanger={false}
                />
            </Row>

            <Row align="middle" justify="center">
                <Button
                    className="button-light-yellow"
                    style={{ marginTop: 35, marginBottom: 50, height: 40, width: 160 }} onClick={toggleModal}>ĐÓNG</Button>
            </Row>
        </Modal>
    )
}

export default AuctionHistoryDetail